// Add this function to open files in a new tab
export const openFileInNewTab = (fileUrl: string) => {
  window.open(fileUrl, '_blank');
};
// Get appropriate background color for attachments
export const getAttachmentBgColor = (isUser: boolean, isAIAgent: boolean) => {
  if (isUser) {
    return 'gray.400';
  } else if (isAIAgent) {
    return 'green.400';
  } else {
    return 'blue.400';
  }
};

// Get the lighter highlight background for file icons
export const getFileIconBgColor = (isUser: boolean, isAIAgent: boolean) => {
  if (isUser) {
    return 'white';
  } else if (isAIAgent) {
    return 'green.300';
  } else {
    return 'blue.300';
  }
};

// Get appropriate background color for message bubbles
export const getMessageBubbleBgColor = (
  isUser: boolean,
  isAIAgent: boolean,
) => {
  if (isUser) {
    return 'gray.100'; // Light gray for users
  } else if (isAIAgent) {
    return 'green.100'; // Green for AI agents
  } else {
    return 'blue.50'; // Blue for human agents/employees
  }
};

// Get appropriate text color for message bubbles
export const getMessageBubbleTextColor = (
  isUser: boolean,
  isAIAgent: boolean,
) => {
  if (isUser) {
    return 'gray.500'; // Dark text for gray background
  } else if (isAIAgent) {
    return 'green.600'; // Dark text for gray background
  } else {
    return 'blue.500'; // White text for blue/green backgrounds
  }
};

// Set colors based on divider type
export const getColors = (type: 'takeover' | 'ai-takeover' | 'time') => {
  switch (type) {
    case 'takeover':
      return {
        lineColor: 'blue.200',
        textColor: 'blue.500',
        bgColor: 'blue.50',
      };
    case 'ai-takeover':
      return {
        lineColor: 'green.200',
        textColor: 'green.500',
        bgColor: 'green.50',
      };
    default:
      return {
        lineColor: 'gray.200',
        textColor: 'gray.500',
        bgColor: 'transparent',
      };
  }
};

// Format the timestamp
export const formatTime = (dateString: string) => {
  try {
    const date = new Date(dateString);
    // Use the browser's timezone for displaying timestamps
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return '';
  }
};

export const defaultConversationFilters = {
  is_read: undefined,
  is_unread: false,
  has_agent_active: undefined,
  has_attachments: undefined,
  isMember: undefined,
  searchTerm: '',
};
